export const cityName = "Лопатинська"
export const cityCouncil = "селищна рада"
export const altCityName = "Логотип Лопатинської селищної ради"

export const territory_title = "Лопатинська селищна рада"
export const territory_title_instrumental = "Лопатинської селищної територіальної громади"

export const website_name = "Портал місцевих податків Лопатинської громади"
export const website_url = "https://lopatynsk.skydatagroup.com/"
export const website_url_p4v = "https://p4v.lopatynsk.skydatagroup.com/"
export const telegram_name ="Місцеві податки Лопатинської ТГ"
export const telegram_url ="https://t.me/Lopatynsk_taxes_bot"
export const phone_number_GU_DPS = "(03-249) 3-98-51"
export const alt_qr_code = "Qr-code Лопатин"
export const GU_DPS_region = "Львівській області"